export default "__VITE_ASSET__561b0172__"